import { compareValues } from "@/utils/sort-value";
import moment from "moment";

const state = {
    customFieldData: [],
    editCustomFieldData: {},
    customFieldExtraData: null,
    dynamicDialogVisible: null
};

const mutations = {
    SET_CUSTOM_FIELD_DATA: (state, info) => {
        state.customFieldData = [...info];
    },
    SET_EDIT_CUSTOM_FIELD_DATA: (state, info) => {
        state.editCustomFieldData = { ...info };
    },
    SET_CUSTOM_FIELD_EXTRA_DATA: (state, info) => {
        state.customFieldExtraData = info;
    },
    SET_DYNAMIC_DIALOG_VISIBILITY: (state, info) => {
        state.dynamicDialogVisible = info;
    }
};

const actions = {
    setCustomFieldData({ commit }, info) {
        var arr = [];
        if (info) {
            arr = info.sort(compareValues("sequence", "asc"));
        }

        arr.forEach(item => {
            if (item.defaultValue) {
                item.value = item.defaultValue;
            }
            if (item.defaultTimespanValue != null) {
                item.value = moment(Date.now() + (item.defaultTimespanValue));
            }
        });

        commit("SET_CUSTOM_FIELD_DATA", arr);
    },
    async setEditCustomFieldData({ commit }, payload) {
        if (payload.custom_fields && payload.custom_fields.length > 0) {
            var custom_fields = payload.custom_fields.sort(compareValues("sequence", "asc"));
            await custom_fields.forEach(field => {
                payload.current_values.extensionDataList.forEach(currentItem => {
                    if (field.inputType.code == "SUBJECT_LOOKUP") {
                        if (field.id == currentItem.customFieldId) {
                            let inputCode = field.lookupFixedHeaderField?.code || field.lookupCustomField?.inputType?.code;
                            switch (inputCode) {
                            case "SUBJECT_STATUS":
                            case "SUBJECT_LOCATED_AT":
                            case "AMOUNT":
                                field.value = parseInt(currentItem.rawValue);
                                break;
                            
                            default:
                                field.value = currentItem.rawValue;
                                break;
                            }
                            field.lookupSubjectQRCode = currentItem.lookupSubjectQRCode;
                        }
                    }
                    else {
                        if (field.id == currentItem.customFieldId) {
                            field.value = currentItem.value;
                        }
                    }
                });
            });

            payload.custom_fields.forEach(item => {
                if (item.defaultValue && item.value == null) {
                    item.value = item.defaultValue;
                }
                if (item.defaultTimespanValue != null && item.value == null) {
                    item.value = moment(Date.now() + (item.defaultTimespanValue));
                }
            });
        }
            
        var editObj = {
            "editInfo": payload.current_values,
            "customFields": payload.custom_fields ? JSON.parse(JSON.stringify(payload.custom_fields)) : ""
        };

        commit("SET_EDIT_CUSTOM_FIELD_DATA", editObj);
    },
    setCustomFieldExtraData({ commit }, payload) {
        commit("SET_CUSTOM_FIELD_EXTRA_DATA", payload);
    },
    setDynamicDialogVisibility({ commit }, payload) {
        commit("SET_DYNAMIC_DIALOG_VISIBILITY", payload);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/custom_field_data.js